'use strict';
import {FileDataCacheService} from './FileDataCacheService';
import {FileUtilities} from './FileUtilities';
import {PersistentUploaderFactory} from './PersistentUploaderFactory';
import {PersistentUploaderService} from './PersistentUploaderService';
import {UploadStatus} from './UPLOAD_STATUS';


/**
 * Module dependencies
 */
const angular = require('angular');

const PendingUploadDirective = require('./pending-upload/PendingUploadDirective.js');

module.exports = angular
  .module('app.core-utilities.upload-service', [])
  .constant('UPLOAD_STATUS', UploadStatus)
  .config(require('./$httpDecorator.js'))
  .config([
    'FileStackProvider',
    'APP_ENV',
    function (FileStackProvider, APP_ENV) {
      FileStackProvider.apiKey(APP_ENV.FILESTACK_API_KEY);
      FileStackProvider.storeContainer(APP_ENV.FILESTACK_STORE);
    }])
  .provider('FileStack', require('./FileStack.js'))
  .service(FileDataCacheService.SERVICE_NAME, FileDataCacheService)
  .service('FileUtilities', FileUtilities)
  .factory('LocalFileDataService', require('./LocalFileDataService.js'))
  .service(PersistentUploaderService.SERVICE_NAME, PersistentUploaderService)
  .service('PersistentUploaderFactory', PersistentUploaderFactory)

  .directive('onFileDrop', require('./FileDropDirective.js'))
  .directive('pendingUploadItem', PendingUploadDirective.directive)
  .run(PendingUploadDirective.templates);



// WEBPACK FOOTER //
// ./src/js/core-utilities/upload-service/index.js